import type { IntlShape } from 'react-intl';

import { getBannerHeaders } from '@/pages/PromotionalBanners/utils/getBannerHeaders';

export const getPromotionalBannerHeaders = (intl: IntlShape) =>
    getBannerHeaders(intl, {
        intlPrefix: 'promotionalBanner',
        linkColumnKey: 'promotionalBanner.table.linkType',
        statusWidth: 120,
    });
